import http from '../util/http.js'

export const projectTypeList = (name,projectId,page,pageSize = 10) => http.get('/projectType/list',{name,projectId,page,pageSize})
export const projectTypeListData = (projectId) => http.get('/projectType/listData',{projectId})
export const projectTypeDetele = (id) => http.get('/projectType/delete',{id})
export const projectTypeSave = (params) => http.post('/projectType/save',params)


